var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 7,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C29B40",
    d: "m4.278.353.568.998a.3.3 0 0 0 .204.154l1.093.25A.76.76 0 0 1 6.53 2.99l-.74.865a.33.33 0 0 0-.078.25l.111 1.152a.732.732 0 0 1-1.016.762l-1.025-.463a.3.3 0 0 0-.253 0l-1.025.463a.732.732 0 0 1-1.004-.762l.108-1.152a.33.33 0 0 0-.077-.25L.79 2.99a.76.76 0 0 1 .386-1.235l1.093-.25a.3.3 0 0 0 .204-.154l.571-.998a.716.716 0 0 1 1.235 0"
  })));
};
export default SvgStar;